export const mobileorderPaymentLabelField = "mobileorderLabel";
export const mobileorderPaymentDisplayLabelField = "mobileorderDisplayLabel";

function normalizeLabel(value: any): string | null {
  if (typeof value !== "string") {
    return null;
  }

  const label = value.trim();
  return label ? label : null;
}

export function getMoBaseLanguage(groupApp: any): string {
  const baseLanguage =
    groupApp &&
    Array.isArray(groupApp.languages) &&
    groupApp.languages.find((language) => language && language.mo_base);

  // Mirrors app.component getBaseLanguageCode: the app falls back to "el", not
  // "en", when no language is flagged mo_base.
  return baseLanguage && baseLanguage.code ? baseLanguage.code : "el";
}

export function resolveMobileorderPaymentLabel(
  paymentMethod: any,
  selectedLanguage?: string,
  baseLanguage?: string
): string | null {
  const label = paymentMethod && paymentMethod[mobileorderPaymentLabelField];
  const directLabel = normalizeLabel(label);

  if (directLabel) {
    return directLabel;
  }

  if (!label || typeof label !== "object" || Array.isArray(label)) {
    return null;
  }

  const preferredLanguages = [
    selectedLanguage,
    baseLanguage,
    "el",
    "en",
  ].filter((language) => !!language);

  for (const language of preferredLanguages) {
    const localizedLabel = normalizeLabel(label[language]);
    if (localizedLabel) {
      return localizedLabel;
    }
  }

  for (const language of Object.keys(label)) {
    const localizedLabel = normalizeLabel(label[language]);
    if (localizedLabel) {
      return localizedLabel;
    }
  }

  return null;
}

export function applyMobileorderPaymentDisplayLabels(
  paymentGateways: any,
  selectedLanguage?: string,
  baseLanguage?: string
) {
  if (!paymentGateways) {
    return;
  }

  Object.keys(paymentGateways).forEach((paymentMethodID) => {
    const paymentMethod = paymentGateways[paymentMethodID];
    if (!paymentMethod) {
      return;
    }

    const displayLabel = resolveMobileorderPaymentLabel(
      paymentMethod,
      selectedLanguage,
      baseLanguage
    );

    if (displayLabel) {
      paymentMethod[mobileorderPaymentDisplayLabelField] = displayLabel;
    } else {
      delete paymentMethod[mobileorderPaymentDisplayLabelField];
    }
  });
}
